import { useContext } from 'react';

import { Form } from 'react-bootstrap';
import { UserContext } from '../../context/UserContext';

const SuporteTi = props => {
  const { isConsulta } = useContext(UserContext);
  let subcategorias;
  
  if (props.getCategorias?.find(categoria => categoria.id === 1)?.subcategoria && props.unidade !== 'DTEC - Diretoria de Gestão do Trabalho, Ensino e Produção do Conhecimento') {
    subcategorias = props.getCategorias?.find(categoria => categoria.id === 1)?.subcategoria.filter(item => item.nome !== 'Criação de e-mail corporativo');
  } else {
    subcategorias = props.getCategorias?.find(categoria => categoria.id === 1)?.subcategoria;
  }

  const isConsultaNoSubcategories = [
    'Manutenção de rede/internet',
    'Manutenção de impressoras/scanners/pendrives',
    'Manutenção VOIP (Telefone Fixo)',
    'Criação/alteração de grupos de e-mail',
    'Instalação de equipamentos de TI',
    'Liberação de Sites e Aplicações',
    'Criação de e-mail corporativo',
  ];

  if (isConsulta) {
    subcategorias = subcategorias?.filter(item => !isConsultaNoSubcategories.includes(item.nome));
  }
  
  return (
    <>
      <Form.Group controlId="formSubCategoria" className="mt-4">
        <Form.Label>*Subcategoria:</Form.Label>
        <Form.Select
          className="border border-secondary"
          required
          name="formSubCategoria"
          onChange={e => props.handleSubcategoria(e)}
        >
          <option value="">Selecione a Subcategoria</option>
          {subcategorias.map(item => (
            <option key={item.nome} value={item.nome}>
              {item.nome}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
    </>
  );
};

export default SuporteTi;
